import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Page } from 'components'
import { useLocalization } from 'components/methods'
import OfflineBoltIcon from '@material-ui/icons/OfflineBolt'
import { Color } from 'theme/style'

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },
  iconContainer: {
    width: '70px',
    height: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    width: '50px',
    height: '50px',
    color: Color.Error
  },
  title: {
    ...theme.typography.h1,
    width: '100%',
    textAlign: 'center'
  },
  description: {
    ...theme.typography.body1,
    width: '100%',
    textAlign: 'center'
  }
}))

const UnavailableMerchant = () => {
  const { t } = useLocalization()
  const classes = useStyles()

  return (
    <Page fullscreen={true} title={t('GEL.whitelabel.screen.unavailable-merchant.title-tab')}>
      <div className={classes.content}>
      <div className={classes.iconContainer}><OfflineBoltIcon className={classes.icon} /></div>
        <div className={classes.title}>{t('GEL.whitelabel.screen.unavailable-merchant.title')}</div>
        <div className={classes.description}>{t('GEL.whitelabel.screen.unavailable-merchant.description')}</div>
      </div>
    </Page>
  )
}

export default UnavailableMerchant
